import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

export const useSiteVisitDemoUser = () =>
	useSendEvent(events.auth.siteVisitDemoUser, undefined, {
		forceSendNoUser: true,
	});
